import {
  GET_PAGINATED_SUBSCRIPTIONS,
  GETTING_PAGINATED_SUBSCRIPTIONS_SUCCEEDED,
  GETTING_PAGINATED_SUBSCRIPTIONS_FAILED,
  UPDATE_CURRENT_EDIT,
  UPDATE_RESUBSCRIBE,
  UPDATE_RESUBSCRIBE_SUCCEEDED,
  UPDATE_RESUBSCRIBE_FAILED,
  CLEAR_SUBSCRIPTION_STORE,
  UPDATE_UNSUBSCRIBE_FILTERS,
  RESET_UNSUBSCRIBE_FILTERS,
  GET_UNSUBSCRIBE_COUNT,
  GET_UNSUBSCRIBE_COUNT_SUCCEEDED,
  GET_UNSUBSCRIBE_COUNT_FAILED
} from './actions';
import { createReducer } from '@reduxjs/toolkit';

const initialState = {
  gettingPaginated: true,
  gettingUnsubscribeCount: false,
  unsubscribeCount: 0,
  updating: false,
  lastUpdateStatus: null,
  paginatedList: [],
  filters: {
    pageNo: 0,
    searchInput: '',
    sortBy: 'emailAddress',
    sortOrder: 'ASC',
    rowsPerPage: 10,
    totalCount: 0,
    displayActive: true,
    filterAllPromotional: [],
    filterAllTransactional: [],
    filterPaginatedCampaigns: []
  },
  currentEdit: {}
};

export default createReducer(initialState, {
  [GET_PAGINATED_SUBSCRIPTIONS]: state => {
    state.gettingPaginated = true;
    state.paginatedList = [];
    state.lastUpdateStatus = null;
    state.error = {};
    return state;
  },
  [GETTING_PAGINATED_SUBSCRIPTIONS_SUCCEEDED]: (state, action) => {
    state.gettingPaginated = false;
    state.paginatedList = action?.payload.map(template => ({
      ...template
    }));
    return state;
  },
  [GETTING_PAGINATED_SUBSCRIPTIONS_FAILED]: (state, action) => {
    state.gettingPaginated = false;
    state.paginatedList = [];
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [UPDATE_CURRENT_EDIT]: (state, action) => {
    let updatedCampaignUuids = action.payload.campaignUuids.map(campaign => campaign.value);
    state.currentEdit = { ...action.payload, campaignUuids: updatedCampaignUuids };
    return state;
  },
  [UPDATE_RESUBSCRIBE]: state => {
    state.updating = true;
    state.lastUpdateStatus = null;
    return state;
  },
  [UPDATE_RESUBSCRIBE_SUCCEEDED]: state => {
    state.updating = false;
    state.lastUpdateStatus = 'success';
    return state;
  },
  [UPDATE_RESUBSCRIBE_FAILED]: state => {
    state.updating = false;
    state.lastUpdateStatus = 'failure';
    return state;
  },
  [CLEAR_SUBSCRIPTION_STORE]: state => {
    let updatedState = {
      ...initialState
    };
    return updatedState;
  },
  [UPDATE_UNSUBSCRIBE_FILTERS]: (state, action) => {
    state.gettingPaginated = true;
    state.filters = {
      ...state.filters,
      ...action.payload
    };
    return state;
  },
  [RESET_UNSUBSCRIBE_FILTERS]: state => {
    state.gettingPaginated = true;
    state.filters = { ...initialState.filters };
    return state;
  },
  [GET_UNSUBSCRIBE_COUNT]: state => {
    state.gettingUnsubscribeCount = true;
    state.unsubscribeCount = 0;
    return state;
  },
  [GET_UNSUBSCRIBE_COUNT_SUCCEEDED]: (state, action) => {
    state.gettingUnsubscribeCount = false;
    state.unsubscribeCount = action.payload;
    return state;
  },
  [GET_UNSUBSCRIBE_COUNT_FAILED]: state => {
    state.gettingUnsubscribeCount = false;
    state.unsubscribeCount = 0;
    return state;
  }
});
